import { render, staticRenderFns } from "./ProjectHome.vue?vue&type=template&id=37c44580&"
import script from "./ProjectHome.vue?vue&type=script&lang=js&"
export * from "./ProjectHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports